import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

/** One message, from the reader's side. `turn_off` is null when it cannot be stopped. */
export interface HeardItem {
  when: string
  /** "Email and in the app", or "In the app only". */
  channel: string
  turn_off: string | null
}

export interface HeardGroup {
  role: string
  label: string
  items: HeardItem[]
}

export interface WhatYouHear {
  groups: HeardGroup[]
}

/** What each kind of user hears from the app (GET /notifications/what-you-hear). */
export function useWhatYouHear() {
  return useQuery<WhatYouHear>({
    queryKey: ['notifications', 'what-you-hear'],
    queryFn: async () => (await api.get('/notifications/what-you-hear')).data,
    staleTime: Infinity,
  })
}

/** The catalogue as markdown, so the Help page renders it like its other sections. */
export function whatYouHearMarkdown(data: WhatYouHear): string {
  const parts = ['Every message shows in the app (the bell). Most also email you.']
  for (const group of data.groups) {
    parts.push(`## ${group.label}`)
    parts.push('| You hear about it when… | How | Can you turn it off? |')
    parts.push('|---|---|---|')
    for (const item of group.items) {
      parts.push(`| ${item.when} | ${item.channel} | ${item.turn_off ?? 'No'} |`)
    }
    parts.push('')
  }
  return parts.join('\n')
}
